import React from "react";
import { MapPin, Clock, Phone } from "lucide-react";
import { company } from "../mock";

const TopBar = () => {
  return (
    <div className="hidden md:block bg-brand-navy text-brand-cream/90 text-[13px]">
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <MapPin className="w-4 h-4 text-brand-orange" />
          <span>{company.areaLabel}</span>
        </div>
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-brand-orange" />
            <span>{company.hours}</span>
          </div>
          <a
            href={company.phoneHref}
            className="flex items-center gap-2 font-semibold text-white hover:text-brand-orange transition-colors"
          >
            <Phone className="w-4 h-4 text-brand-orange" />
            {company.phone}
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
